/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaAudioMicAIcon16Light } from './MediaAudioMicAIcon16Light';
import { MediaAudioMicAIcon16Regular } from './MediaAudioMicAIcon16Regular';
import { MediaAudioMicAIcon16Solid } from './MediaAudioMicAIcon16Solid';
import { MediaAudioMicAIcon20Light } from './MediaAudioMicAIcon20Light';
import { MediaAudioMicAIcon20Regular } from './MediaAudioMicAIcon20Regular';
import { MediaAudioMicAIcon20Solid } from './MediaAudioMicAIcon20Solid';
import { MediaAudioMicAIcon24Regular } from './MediaAudioMicAIcon24Regular';
import { MediaAudioMicAIcon24Solid } from './MediaAudioMicAIcon24Solid';
import { MediaAudioMicAIcon32Regular } from './MediaAudioMicAIcon32Regular';
import { MediaAudioMicAIcon64Regular } from './MediaAudioMicAIcon64Regular';
var sizes = {
    16: {
        light: MediaAudioMicAIcon16Light,
        regular: MediaAudioMicAIcon16Regular,
        solid: MediaAudioMicAIcon16Solid,
    },
    20: {
        light: MediaAudioMicAIcon20Light,
        regular: MediaAudioMicAIcon20Regular,
        solid: MediaAudioMicAIcon20Solid,
    },
    24: {
        regular: MediaAudioMicAIcon24Regular,
        solid: MediaAudioMicAIcon24Solid,
    },
    32: {
        regular: MediaAudioMicAIcon32Regular,
    },
    64: {
        regular: MediaAudioMicAIcon64Regular,
    },
};
export var MediaAudioMicAIcon = forwardRef('MediaAudioMicAIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
